import { apiGet } from '@gat-ship/http-client'
import type { CountryRef } from '@gat-ship/types'

export async function getCountryRefsRequest() {
  return await apiGet<CountryRef[]>('ref-data/geography/countries')
}
